import { UISDK } from "@/ui-sdk";
import { flagCheck } from "..";
import { getLowTicketSizeRecommendationFromHandles } from "./utils/get-low-ticket-size-recommendations";

export default async function handleLowTicketRecommendation(
  element: HTMLElement,
  sdk: UISDK,
) {
  if (!flagCheck("low-ticket-size-recommendation")) return;

  await new Promise((resolve) => setTimeout(resolve, 1_000));
  const cart = await fetch("/cart.js").then((res) => res.json());

  // get handle of 1st item in cart and fetches low ticket size recommendations for that
  const handle = cart.items[0].handle;
  const lowTicketSize = await getLowTicketSizeRecommendationFromHandles([
    handle,
  ]);

  const filteredLowTicketSize =
    lowTicketSize && typeof lowTicketSize === "object"
      ? Object.fromEntries(
          Object.entries(lowTicketSize)
            .filter(([_, value]) => value?.complementary?.length > 0)
            .map(([key, value]) => {
              let text = key;
              if (text.toLowerCase() === "handbags") {
                text = "Yoga Mat";
              }
              return [text, value];
            }),
        )
      : {};

  return sdk.renderLowTicketRecommendation(
    {
      c: [],
      s: [],
      key: Date.now().toString(),
      loading: false,
      currentProductHandle: handle,
      lowTicketSize: filteredLowTicketSize,
    },
    element,
  );
}
